import { render, staticRenderFns } from "./bscbo1.vue?vue&type=template&id=8186812e&"
import script from "./bscbo1.vue?vue&type=script&lang=js&"
export * from "./bscbo1.vue?vue&type=script&lang=js&"
import style0 from "./bscbo1.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports